// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__Afy4U","label":"LabeledBox_label__2WFNM"};